import { MyUtils } from "src/app/services/my-utils.service";
import { InterviewDetail } from "../table-links-modal/models/interview-details"
import { Injectable } from "@angular/core";

interface CustomerData extends Record<string, string> {
    "FirstName": string,
    "LastName": string,
    "Region": string,
    "Market": string,
    "E-mail": string,
    "Phone": string,
    "Dealer": string,
    "outletName": string,
    "agent": string,
    "Importer": string,
}

interface EuropeanCustomerData extends Record<string, string> {
    "FirstName": string,
    "LastName": string,
    "Region": string,
    "Market": string,
    "E-mail": string,
    "Phone": string,
    "Dealer": string,
    "outletName": string,
    "agent": string,
    "Importer": string,
}

interface CecCustomerData extends Record<string, string> {
    "FirstName": string,
    "LastName": string,
    "Phone": string,
    "E-mail": string,
}

interface VehicleData extends Record<string, string> {
    "Brand": string,
    "vin": string,
    "Model": string,
}

interface CecVehicleData extends Record<string, string> {
    "Brand": string,
    "vin": string,
    "Model": string,
    "Engine Type": string,
    "Vehicle Type": string,
}

interface SurveyData extends Record<string, string> {
    "responseChannel": string,
    "responseDate": string,
    "eventDate": string,
}

interface CecCaseData extends Record<string, string> {
    "caseNumber": string,
    "interviewType": string,
    "importer": string,
    "dealerCec": string,
    "Opened": string,
    "Closed": string
}



@Injectable()
export class InterviewDetailsMapper {

    customerMapper: { [x: string]: (arg0: InterviewDetail) => CustomerData | EuropeanCustomerData } = {
        "customerData": (details) => {
            return {
                "FirstName": details.firstName,
                "LastName": details.lastName,
                "Region": details.region ? this.utils.traslatei18n(details.region, "regionTrad") : '',
                "Market": details.market ? this.utils.traslatei18n(details.market, "marketTrad") : '',
                "E-mail": details.emailaddress,
                "Phone": details.cellphone,
                "Dealer": details.dealerName,
                "outletName": details.outletName,
                "agent": details.agentName,
                "Importer": details.distributorName,
            }
        },
        "europeanCustomerData": (details) => {
            return {
                "FirstName": details.firstName,
                "LastName": details.lastName,
                "Region": details.region ? this.utils.traslatei18n(details.region, "regionTrad") : '',
                "Market": details.market ? this.utils.traslatei18n(details.market, "marketTrad") : '',
                "E-mail": details.emailaddress,
                "Phone": details.cellphone,
                "Dealer": details.dealerName,
                "outletName": details.outletName,
                "agent": details.agentName,
                "Importer": details.distributorName,
            }
        }
    }


    constructor(private utils: MyUtils) {

    }
    public mapInterviewDetails(detail: InterviewDetail): Map<string, Record<string, string>> {
        const mappedDetails = new Map<string, Record<string, string>>([
            ['customerData', this.mapCustomerData(detail)],
            ['vehicleData', this.mapVehicleData(detail)],
            ['surveyData', this.mapSurveyData(detail)],
        ]);
        return mappedDetails;
    }

    public mapCecInterviewDetails(detail: InterviewDetail): Map<string, Record<string, string>> {
        const mappedDetails = new Map<string, Record<string, string>>([
            ['customerData', this.mapCecCustomerData(detail)],
            ['vehicleData', this.mapCecVehicleData(detail)],
            ['surveyData', this.mapSurveyData(detail)],
            ['caseData', this.mapCecCaseData(detail)],
        ])
        return mappedDetails;
    }

    private mapCustomerData(detail: InterviewDetail): CustomerData | EuropeanCustomerData {
        const isEuro = this.utils.settingsPayloadValue.payload.network.regions[0].region === 'EUR';
        return this.customerMapper[isEuro ? 'europeanCustomerData' : 'customerData'](detail);
    }


    private mapCecCustomerData(detail: InterviewDetail): CecCustomerData {
        return {
            "FirstName": detail.firstName,
            "LastName": detail.lastName,
            "Phone": detail.cellphone,
            "E-mail": detail.emailaddress,
        }
    }

    private mapCecVehicleData(detail: InterviewDetail): CecVehicleData {
        const vehicleData: CecVehicleData = {
            "Brand": this.utils.traslatei18n(detail?.brand),
            "vin": detail?.vin,
            "Model": detail?.productName,
            "Engine Type": detail.engineType,
            "Vehicle Type": detail.productType,
        };
        return vehicleData;
    }
    private mapVehicleData(detail: InterviewDetail): VehicleData {
        const vehicleData: VehicleData = {
            "Brand": this.utils.traslatei18n(detail?.brand),
            "vin": detail?.vin,
            "Model": detail?.productName,
        };
        return vehicleData;
    }

    private mapSurveyData(detail: InterviewDetail): SurveyData {
        const surveyData: SurveyData = {
            "responseChannel": detail?.responseChannel,
            "responseDate": detail?.responseDate,
            "eventDate": detail?.eventDate,
        };
        return surveyData;
    }


    private mapCecCaseData(detail: InterviewDetail): CecCaseData {
        const caseData: CecCaseData = {
            "caseNumber": detail.caseNumber,
            "interviewType": detail.caseType,
            "importer": detail.distributorName,
            "dealerCec": detail.dealerName,
            "Opened": detail.caseOpenDate,
            "Closed": detail.caseCloseDate
        };
        return caseData;
    }
}